import React from 'react';
import Lokasyon from '../pages/Lokasyon';

const sampleStats = {
  ikitelli: { aktif: 28, kapali: 9, sigorta_basvuru_bekleyen: 3 },
  hadimkoy: { aktif: 17, kapali: 5, sigorta_basvuru_bekleyen: 1 },
};

const noop = () => {};

export default function DashboardPreview() {
  return (
    <Lokasyon
      kullanici={{ ad_soyad: 'Doruk Kantar', kullanici_adi: 'dkantar', rol: 'yonetici', lokasyon: 'ikitelli' }}
      canGor={() => true}
      onLokasyonSec={noop}
      onMuhasebe={noop}
      onArsiv={noop}
      onSatinAlma={noop}
      onFinans={noop}
      onAdmin={noop}
      onIhaleTakip={noop}
      onTeklifler={noop}
      onCari={noop}
      onAcilParca={noop}
      onSigortaBasvuru={noop}
      onCikis={noop}
      previewStats={sampleStats}
      previewUrgent={{ bekleyen_sayisi: 4, liste: [] }}
    />
  );
}
